import { createTheme } from '@material-ui/core/styles';

export const matteTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#3f4a51',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#000000',
            contrastText: '#FFFFFF',
        },
        divider: '#f2f4f8',
    },
});
